/**
 * Api service
 */
export default class Service {

  /**
   * The api service model
   */
  model() {
    return null
  }

  /**
   * 
   */
  static toList() {
    return new this().model()
  }
}